export default __webpack_public_path__ + "static/media/Logo_Assembly_Employee_Recognition_1x.959a9efe.webp";